import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRef } from "react";
import { ProductCardUI } from "@/components/product-card/product-card-ui";
import { ProductDetailsResponse } from "@/types/product";
import Image from "next/image";
import RelatedItemHeading from "../related-item-heading";
import RelatedItemList from "../related-item-list";

interface Props {
  products: ProductDetailsResponse[];
}

const settings = {
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
};

export const RelatedItems = ({ products }: Props) => {
  const sliderRef = useRef<null | Slider>(null);

  const nextSlide = () => {
    sliderRef.current?.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current?.slickPrev();
  };

  return (
    <section className="container px-4 my-8 m-auto">
      <div className="flex justify-between">
        <RelatedItemHeading />
        <div className="flex sm:hidden justify-center items-center gap-3">
          <button
            onClick={prevSlide}
            className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
          >
            <Image
              src="/img/arrow-left-slide.svg"
              alt="Previous"
              width={20}
              height={20}
            />
          </button>
          <button
            onClick={nextSlide}
            className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
          >
            <Image
              src="/img/arrow-right-slide.svg"
              alt="Next"
              width={20}
              height={20}
            />
          </button>
        </div>
      </div>

      <div className="max-w-screen sm:hidden">
        <Slider ref={sliderRef} {...settings}>
          {products.map((list) => (
            <ProductCardUI
              key={list.id}
              product={list}
              pageType="relatedProduct"
            />
          ))}
        </Slider>
      </div>
      <RelatedItemList lists={products} />
    </section>
  );
};
